export default "__VITE_ASSET__adbc145d__"